module.exports = __webpack_public_path__ + "img/saudi.760bf374.svg";